import { ContentTemplate } from './content-template';
import { ContentType } from './content-type';

export interface Hint extends ContentTemplate {
  type: ContentType.HINT;
  text: string;
}
